<template>
  <div id="app" :class="{'theme-light': appState.theme === 'light', 'theme-dark': appState.theme === 'dark', 'theme-contrast': appState.theme === 'contrast'}">
    <FreeFlightMobileControls v-if="mapViewer.mapState === 'loaded' && appState.controls.state === 'free'" />
    <ZoomButtons v-if="showMapMenu && appState.controls.showZoomButtons && appState.controls.state !== 'free'" />
    <ControlBar />
    <div v-if="mapViewer.mapState !== 'loaded'" class="map-state-message">{{ $t("map." + mapViewer.mapState) }}</div>
    <!-- [FORK] permanent notices: delayed-updates justification + claim-ticket info -->
    <div class="bottom-notices">
      <template v-if="!noticesCollapsed">
        <div class="notice notice-warning" title="Cliquer pour réduire" @click="toggleNotices">⚠️ Pour économiser les performances du serveur, l'actualisation de la map, des joueurs et des claims peut être décalée.</div>
        <div class="notice notice-info" title="Cliquer pour réduire" @click="toggleNotices">ℹ️ Un claim totalement inactif ou volontairement anti-jeu bloque votre expansion ? Ouvrez un ticket avec les coordonnées pour voir si le staff peut vous aider.</div>
        <div class="notices-toggle" title="Réduire" @click="toggleNotices">✕</div>
      </template>
      <div v-else class="notices-collapsed" title="Afficher les informations" @click="toggleNotices">⚠️ ℹ️</div>
    </div>
    <MainMenu :menu="appState.menu" />
  </div>
</template>

<script>
import ControlBar from "./components/ControlBar/ControlBar.vue";
import MainMenu from "./components/Menu/MainMenu.vue";
import FreeFlightMobileControls from "./components/Controls/FreeFlightMobileControls.vue";
import ZoomButtons from "./components/Controls/ZoomButtons.vue";

export default {
  name: 'App',
  components: {
    FreeFlightMobileControls,
    MainMenu,
    ControlBar,
    ZoomButtons
  },
  computed: {
    showMapMenu() {
      return this.mapViewer.mapState === "loading" || this.mapViewer.mapState === "loaded";
    }
  },
  data() {
    // [FORK] notices start collapsed on mobile, and the visitor's choice is remembered
    let noticesCollapsed;
    try {
      let stored = localStorage.getItem("bluemap-notices-collapsed");
      noticesCollapsed = stored !== null ? stored === "true" : window.matchMedia("(max-width: 575.98px)").matches;
    } catch (e) {
      noticesCollapsed = false;
    }

    return {
      appState: this.$bluemap.appState,
      mapViewer: this.$bluemap.mapViewer.data,
      noticesCollapsed: noticesCollapsed
    }
  },
  methods: {
    // [FORK]
    toggleNotices() {
      this.noticesCollapsed = !this.noticesCollapsed;
      try {
        localStorage.setItem("bluemap-notices-collapsed", this.noticesCollapsed ? "true" : "false");
      } catch (e) { /* ignored */ }
    }
  }
}
</script>

<style lang="scss">
  @import "./scss/global.scss";

  #map-container {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  #app {
    position: absolute;
    width: 100%;
    height: 100%;

    z-index: 10000; // put over bluemap markers

    pointer-events: none;

    font-size: 1rem;
    @media (max-width: $mobile-break) {
      font-size: 1.5rem;
    }

    .map-state-message {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: var(--theme-fg-light);
      line-height: 1em;
      text-align: center;
    }

    // [FORK] permanent notices at the bottom of the screen
    .bottom-notices {
      position: fixed;
      bottom: 0.5em;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.35em;
      // explicit width, because for a fixed element with left:50% the shrink-to-fit
      // width would be limited to the right half of the viewport
      width: max-content;
      max-width: 95vw;
      pointer-events: none;

      .notice {
        padding: 0.4em 0.9em;
        background-color: var(--theme-bg);
        color: var(--theme-fg);
        opacity: 0.92;
        font-size: 0.75em;
        line-height: 1.3em;
        text-align: center;
        border-radius: 0.5em;
        box-shadow: 0 0.15em 0.5em rgba(0, 0, 0, 0.5);
        cursor: pointer;
        pointer-events: auto;
        user-select: none;
      }

      .notice-warning {
        border: 1px solid rgba(255, 204, 51, 0.9);
        border-left: 0.3em solid rgba(255, 204, 51, 0.9);
      }

      .notice-info {
        border: 1px solid rgba(77, 166, 255, 0.9);
        border-left: 0.3em solid rgba(77, 166, 255, 0.9);
      }

      @media (max-width: $mobile-break) {
        .notice {
          font-size: 0.55em;
          line-height: 1.25em;
        }
      }

      .notices-toggle {
        position: absolute;
        top: -0.7em;
        right: -0.7em;
        width: 1.7em;
        height: 1.7em;
        line-height: 1.7em;
        text-align: center;
        font-size: 0.8em;
        background-color: var(--theme-bg);
        color: var(--theme-fg);
        border: 1px solid var(--theme-bg-light);
        border-radius: 50%;
        box-shadow: 0 0.15em 0.5em rgba(0, 0, 0, 0.5);
        cursor: pointer;
        pointer-events: auto;
        user-select: none;
      }

      .notices-collapsed {
        padding: 0.3em 0.8em;
        background-color: var(--theme-bg);
        color: var(--theme-fg);
        border: 1px solid var(--theme-bg-light);
        border-radius: 1em;
        box-shadow: 0 0.15em 0.5em rgba(0, 0, 0, 0.5);
        opacity: 0.9;
        font-size: 0.75em;
        line-height: 1.3em;
        cursor: pointer;
        pointer-events: auto;
        user-select: none;
      }
    }
  }
</style>
